import React, { useEffect, useRef } from "react";
import { Slide, Fade } from "react-awesome-reveal";
import Marquee from "react-fast-marquee";
import partners from "../../../../assets/images/partners/PARTNERS.png";
import partner1 from "../../../../assets/images/partners/partner1.png";
import partner2 from "../../../../assets/images/partners/partner2.png";
import partner3 from "../../../../assets/images/partners/partner3.png";
import partner4 from "../../../../assets/images/partners/partner4.png";
import partner5 from "../../../../assets/images/partners/partner5.png";
import partner6 from "../../../../assets/images/partners/partner6.png";
import partner7 from "../../../../assets/images/partners/partner7.png";
import partner8 from "../../../../assets/images/partners/partner8.png";
import partner9 from "../../../../assets/images/partners/partner9.png";
import partner10 from "../../../../assets/images/partners/partner10.png";
import partner11 from "../../../../assets/images/partners/partner11.png";
import partner12 from "../../../../assets/images/partners/partner12.png";
import partner13 from "../../../../assets/images/partners/partner13.png";
import partner14 from "../../../../assets/images/partners/partner14.png";
import partner15 from "../../../../assets/images/partners/partner15.png";
import row1 from "../../../../assets/images/row1.svg";
import row2 from "../../../../assets/images/row2.svg";
import row3 from "../../../../assets/images/row3.svg";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";

function Partners({ setIsLargeScreen, isLargeScreen }) {
    const sceneRef = useRef(null);
    const imgRef = useRef(null);

    const partnerImages = [
        { id: 1, src: partner1, src2: partner2, direction: "left" },
        { id: 2, src: partner3, src2: partner4, direction: "right" },
        { id: 3, src: partner5, src2: partner6, direction: "left" },
        { id: 4, src: partner7, src2: partner8, direction: "right" },
        { id: 5, src: partner9, src2: partner10, direction: "left" },
        { id: 6, src: partner11, src2: partner12, direction: "right" },
        { id: 7, src: partner13, src2: partner14, direction: "left" },
        { id: 8, src: partner15,  direction: "right" },

    ];

    useEffect(() => {
        const handleScroll = () => {
            if (sceneRef.current && imgRef.current) {
                const scrollY = window.scrollY;
                const translateY = scrollY * -0.7; // Adjust the speed of the parallax effect

                gsap.to(imgRef.current, {
                    y: translateY,
                    duration: 0.5, // Duration of the animation
                    ease: "power2.out", // Easing function
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        gsap.registerPlugin(SplitText);
        const innovationpara = new SplitText("#innovationpara", {
            type: "words",
        });

        gsap.from(innovationpara.words, {
            duration: 3,
            opacity: 0,

            ease: "power1.inOut",
            stagger: {
                each: 0.13,
                from: "start",
            },
        });

        return () => {
            innovationpara.revert();
        };
    }, []);

    const scrollToElement = (id) => {
        const element = document.getElementById(id);

        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: 100, // adjust this value as needed
                },
                ease: "power2.inOut",
            });
        }
    };

    return (
        <div
            id="partners"
            className="relative overflow-hidden text-center flex  w-full flex-col pb-[100px] md:pb-[300px]  z-10 "
        >
            <div className="w-[87%]    relative h-full mx-auto   text-center md:text-left  flex flex-col gap-3 md:pt-[300px] pt-[100px]">
                <div className="flex  md:flex-row flex-col justify-start align-middle items-start md:items-center">
                    <Slide direction="left" triggerOnce>
                        {" "}
                        <h3 className="text-left h8 ">OUR PARTNERS</h3>
                    </Slide>{" "}
                    <h6 className="md:text-center text-left flex justify-center mx-auto h17  my-5">
                        VertexLabs Ecosystem, Investors & Partners
                    </h6>
                </div>{" "}
                {isLargeScreen ? (
                    <div className="">
                        {" "}
                        <div class="absolute h-[2000px] inset-y-0 left-0 w-px  bg-white/10 z-0"></div>
                        <div class="absolute h-[2000px] inset-y-0 left-1/3 w-px bg-white/10 z-0"></div>
                        <div class="absolute h-[2000px] inset-y-0 left-2/3 w-px bg-white/10 z-0"></div>
                        <div class="absolute h-[2000px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                    </div>
                ) : (
                    <div>
                        {" "}
                        <div class="absolute h-[4200px] inset-y-0 left-0 w-px  bg-white/10 z-0"></div>
                        <div class="absolute h-[4200px]  inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                        <div class="absolute h-[4000px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                    </div>
                )}
            </div>{" "}
            {isLargeScreen ? (
                <div className="">
                    <Fade cascade damping={1e-1} triggerOnce>
                        <div className="w-full marquee-container mt-24    ">
                            <Marquee
                                speed={50}
                                autoFill
                                loop={0}
                                direction="left"
                            >
                                <img
                                    src={row1}
                                    className="  align-middle items-center flex w-[800px] sm:w-[1400px] mr-24"
                                    alt=""
                                />
                            </Marquee>
                            <Marquee
                                speed={50}
                                autoFill
                                loop={0}
                                direction="right"
                            >
                                <img
                                    src={row2}
                                    className="my-10 w-[800px] sm:w-[1400px]  align-middle items-center flex mr-24"
                                    alt=""
                                />
                            </Marquee>
                            <Marquee
                                speed={50}
                                autoFill
                                loop={0}
                                direction="left"
                            >
                                <img
                                    className="mt-10 w-[300px] sm:w-[600px]  align-middle items-center flex mr-24"
                                    src={row3}
                                    alt=""
                                />
                            </Marquee>
                        </div>
                    </Fade>
                </div>
            ) : (
                <div className="">
                    <Fade cascade damping={1e-1} triggerOnce>
                        {partnerImages.map((item) => (
                            <div className="w-full marquee-container mt-24   flex flex-col">
                                <Marquee
                                    speed={50}
                                    autoFill
                                    loop={0}
                                    direction={item.direction}
                                >
                                    <img
                                        src={item.src}
                                        className="  align-middle items-center flex w-[90px]  mr-24"
                                        alt=""
                                    />
                                    <img
                                        src={item.src2}
                                        className="  align-middle items-center flex w-[90px] mr-24"
                                        alt=""
                                    />
                                </Marquee>
                            </div>
                        ))}
                    </Fade>
                </div>
            )}
        </div>
    );
}

export default Partners;
